module.exports = __webpack_public_path__ + "static/media/0040_TreeTrimming.2004ee16.JPG";